<template>
  <!--begin::Mixed Widget 1-->
  <div class="card card-custom bg-gray-100 card-stretch gutter-b">
    <!--begin::Header-->
    <div class="card-header border-0 bg-danger py-6">
      <h3 class="card-title font-weight-bolder text-white">
        Status Penerimaan Rapot Kelas {{ tingkat }}
      </h3>
      <div class="card-toolbar">
        <b-button>Reload</b-button>
      </div>
    </div>
    <!--end::Header-->
    <!--begin::Body-->
    <div class="card-body p-0 position-relative overflow-hidden">
      <!--begin::Stats-->
      <div class="card-spacer">
        <!--begin::Row-->
        <div class="row m-0">
          <div class="col-12 col-sm-6 col-md-4">
            <div
              class="card card-custom bg-primary gutter-b"
              style="height: 150px"
            >
              <div class="card-body">
                <span class="svg-icon svg-icon-3x svg-icon-white ml-n2"
                  ><inline-svg src="media/svg/icons/Media/Equalizer.svg"
                /></span>
                <div
                  class="text-inverse-primary font-weight-bolder font-size-h2 mt-3"
                >
                  {{ insight.loginCounter }}
                  <small>dari {{ insight.totalSiswa }} Siswa</small>
                </div>

                <a
                  href="#"
                  class="text-inverse-primary font-weight-bold font-size-lg mt-1"
                  >Siswa Login</a
                >
              </div>
            </div>
          </div>

          <div class="col-12 col-sm-6 col-md-4">
            <div
              class="card card-custom bg-primary gutter-b"
              style="height: 150px"
            >
              <div class="card-body">
                <span class="svg-icon svg-icon-3x svg-icon-white ml-n2"
                  ><inline-svg src="media/svg/icons/Media/Equalizer.svg"
                /></span>
                <div
                  class="text-inverse-primary font-weight-bolder font-size-h2 mt-3"
                >
                  {{ insight.infoLogCounter }}
                  <small>dari {{ insight.loginCounter }} yang login</small>
                </div>

                <a
                  href="#"
                  class="text-inverse-primary font-weight-bold font-size-lg mt-1"
                  >Siswa Melihat Berita Kenaikan</a
                >
              </div>
            </div>
          </div>

          <div class="col-12  col-md-4">
            <div
              class="card card-custom bg-primary gutter-b"
              style="height: 150px"
            >
              <div class="card-body">
                <span class="svg-icon svg-icon-3x svg-icon-white ml-n2"
                  ><inline-svg src="media/svg/icons/Media/Equalizer.svg"
                /></span>
                <div
                  class="text-inverse-primary font-weight-bolder font-size-h2 mt-3"
                >
                  {{ insight.downloadLogCounter }}
                  <small>dari {{ insight.loginCounter }} yang login</small>
                </div>

                <a
                  href="#"
                  class="text-inverse-primary font-weight-bold font-size-lg mt-1"
                  >Siswa Mengunduh Rapot</a
                >
              </div>
            </div>
          </div>

          <div class="col-sm-6 col-md-3">
            <div
              class="card card-custom bg-primary gutter-b"
              style="height: 150px"
            >
              <div class="card-body">
                <span class="svg-icon svg-icon-3x svg-icon-white ml-n2"
                  ><inline-svg src="media/svg/icons/Media/Equalizer.svg"
                /></span>
                <div
                  class="text-inverse-primary font-weight-bolder font-size-h2 mt-3"
                >
                  {{ insight.suspendedCounter }} <small>(total)</small>
                </div>

                <a
                  href="#"
                  class="text-inverse-primary font-weight-bold font-size-lg mt-1"
                  >Siswa Ditunda Login</a
                >
              </div>
            </div>
          </div>

          <div class="col-sm-6 col-md-3">
            <div
              class="card card-custom bg-primary gutter-b"
              style="height: 150px"
            >
              <div class="card-body">
                <span class="svg-icon svg-icon-3x svg-icon-white ml-n2"
                  ><inline-svg src="media/svg/icons/Media/Equalizer.svg"
                /></span>
                <div
                  class="text-inverse-primary font-weight-bolder font-size-h2 mt-3"
                >
                  {{ insight.suspendedInfoLogCounter }}
                  <small>dari {{ insight.suspendedCounter }} Siswa</small>
                </div>

                <a
                  href="#"
                  class="text-inverse-primary font-weight-bold font-size-lg mt-1"
                  >Siswa Tertunda Melihat Berita Penundaan</a
                >
              </div>
            </div>
          </div>

          <div class="col-sm-6  col-md-3">
            <div
              class="card card-custom bg-primary gutter-b"
              style="height: 150px"
            >
              <div class="card-body">
                <span class="svg-icon svg-icon-3x svg-icon-white ml-n2"
                  ><inline-svg src="media/svg/icons/Media/Equalizer.svg"
                /></span>
                <div
                  class="text-inverse-primary font-weight-bolder font-size-h2 mt-3"
                >
                  {{ insight.suspendedVoidCounter }}
                  <small>dari {{ insight.suspendedCounter }} Siswa</small>
                </div>

                <a
                  href="#"
                  class="text-inverse-primary font-weight-bold font-size-lg mt-1"
                  >Siswa Tunda Dibuka</a
                >
              </div>
            </div>
          </div>

          <div class="col-sm-6  col-md-3">
            <div
              class="card card-custom bg-primary gutter-b"
              style="height: 150px"
            >
              <div class="card-body">
                <span class="svg-icon svg-icon-3x svg-icon-white ml-n2"
                  ><inline-svg src="media/svg/icons/Media/Equalizer.svg"
                /></span>
                <div
                  class="text-inverse-primary font-weight-bolder font-size-h2 mt-3"
                >
                  {{ insight.suspendedDownloadLogCounter }}

                  <small>dari {{ insight.suspendedCounter }} Siswa</small>
                </div>

                <a
                  href="#"
                  class="text-inverse-primary font-weight-bold font-size-lg mt-1"
                  >Siswa Tunda Mendownload Rapot</a
                >
              </div>
            </div>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Stats-->
      <!--end::Body-->
    </div>
    <!--end::Mixed Widget 1-->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";

export default {
  name: "widget-1",
  components: {},
  props: ["tingkat"],
  data() {
    return {
      strokeColor: "#D13647",
      chartOptions: {},
      series: [
        {
          name: "Net Profit",
          data: [30, 45, 32, 70, 40, 40, 40]
        }
      ],
      apiURL: "https://backend-siradi2.azurewebsites.net/guru",
      insight: {
        totalSiswa: 0,
        loginCounter: 1,
        infoLogCounter: 1,
        downloadLogCounter: 1,
        suspendedCounter: 44,
        suspendedInfoLogCounter: 0,
        suspendedVoidCounter: 0,
        suspendedDownloadLogCounter: 0
      }
    };
  },
  computed: {
    ...mapGetters(["layoutConfig"])
  },
  mounted() {
    this.fetchInsight();
  },
  methods: {
    fetchInsight() {
      return axios
        .get(this.apiURL + "/getInsight/" + this.tingkat)
        .then(response => {
          this.insight = response.data;
        });
    }
  }
};
</script>
